import { render } from "./TDContract.vue?vue&type=template&id=f0ea1d52"
import script from "./TDContract.vue?vue&type=script&lang=js"
export * from "./TDContract.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__